import { Component, OnInit, TemplateRef, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { G_PurchaseMasterViewModel } from 'src/app/viewmodels/g-purchase/G_PurchaseMasterViewModel';
import { AppConsts } from 'src/app/common/app-consts';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { E_G_EPSStatusType } from 'src/app/viewmodels/g-purchase/E_G_EPSStatusType';
import { SavePurchaseMasterRequest } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';
@Component({
  selector: 'app-purchase-requsition',
  templateUrl: './purchase-requsition.component.html',
  styleUrls: ['./purchase-requsition.component.scss']
})
export class PurchaseRequsitionComponent implements OnInit {
  public SortBy: string = "asc";
  public modalRef: BsModalRef;
  public itemVm: SavePurchaseMasterRequest;
  public invoicesList: any = [];
  public vmListItems: any = [];
  dataTable: any;
  @Input('dataTable') table;
  dtOption: any = {};
  public component_Title = 'Purchase Requsition';

  p = 1; // current page
  size = 10; // records per page
  totalItems = 0;
  searchTerm = '';
  orderBy = 'Id';
  sort = 'Desc';
  pId: number = null;

  public deleteId: string;
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private spinner: NgxSpinnerService
  ) {
    // this._uow.dataService.saveTriggerObservable.subscribe(value =>{
    //   console.log('saved triger',value);
    //   if(value){
    //     this.getList();
    //   }
    // })
  }

  ngOnInit() {
    this.pId = E_G_EPSStatusType.Purchase_Requisition;
    this.getList();
    $('table.display').DataTable();
    //   this.getList();
    //   this.dtOption = {
    //     "paging":   false,
    //     "searching": false,
    //     "info": false,
    // };
    // $(() =>{
    //   $('table.display').DataTable(this.dtOption);
    // })
  }

  ngAfterViewInit() {
  }


  getList() {
    this.spinner.show();
    debugger
    const search = { Name: this.searchTerm }; // adapt per page
    this._uow.gSettingService.getListById("GPurchase", "GetPurchaseRequisitesAsync", this.p, this.size, search, this.orderBy, this.sort, this.pId)
      .subscribe({
        next: (res: any) => {
          debugger
          this.vmListItems = res.result;
          this.totalItems = res.total;
          this.spinner.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinner.hide();
        }
      });
  }

  // called when user types in search box
  getBySearchTerm(event: any) {
    debugger
    this.searchTerm = event.target.value.trim();
    this.p = 1; // reset to first page
    this.getList();
  }

  // pagination handler
  onPageChange(page: number) {
    debugger
    this.p = page;
    this.getList();
  }

  // sorting handler (toggle Asc/Desc)
  getSortIndexList(column: string) {
    this.orderBy = column;
    this.sort = this.sort === 'Asc' ? 'Desc' : 'Asc';
    this.getList();
  }

  // public searchTerm = '';
  // getBySearchTerm(e) {
  //   if (this.searchTerm !== ' ') {
  //     // this._jq.showSpinner(true);
  //     this.spinner.show();
  //     this._uow.purchaseRequisitionService.GetPagedBySearch(this.searchTerm).subscribe((res: any) => {
  //       this.p = 1;
  //       this.vmListItems = res.DtlList;
  //       // this._jq.showSpinner();
  //       this.spinner.hide();
  //     }, (error) => {
  //       console.log(error);
  //       // this._jq.showSpinner();
  //       this.spinner.hide();
  //     });
  //   } else {
  //     this.getList();
  //   }
  // }

  // getSortIndexList(sIndex) {
  //   debugger
  //   // this._jq.showSpinner(true);
  //   this.spinner.show();
  //   this.SortBy = this.SortBy == "asc" ? "desc" : "asc";
  //   this._uow.purchaseRequisitionService.GetPagedResult(0, 50, null, sIndex, this.SortBy).subscribe((res: any) => {
  //     debugger
  //     this._jq.reinitDataTable(res);
  //     this.vmListItems = res.DtlList;;
  //     console.log(res);
  //     this.spinner.hide();
  //     // this._jq.showSpinner();
  //   }, (err) => {
  //     console.log(err);
  //     // this._jq.showSpinner();
  //     this.spinner.hide();
  //   });
  // }

  openAttachmentModal(template: TemplateRef<any>, b) {
    debugger
    this._uow.gPurchaseService.GetGPurchaseByIdAsync(b).subscribe((res: any) => {
      debugger
      this.invoicesList = res.invoicesList;
    });
    this.modalRef = this._uow.modalServiceEx.show(template);
    this.modalRef.setClass('modal-lg');
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this._uow.modalServiceEx.show(template);
    this.modalRef.setClass('modal-xl');
  }



  //getList() {
  //   // this._jq.showSpinner(true);
  //   this.spinner.show();
  //this._uow.purchaseRequisitionService.GetList().subscribe((res: any) => {
  //     this._jq.reinitDataTable(res);
  //     this.vmListItems = res.DtlList;
  //     console.log(res);

  //     // this._jq.showSpinner();
  //     this.spinner.hide();
  //   }, (err) => {
  //     console.log(err);
  //     // this._jq.showSpinner();
  //     this.spinner.hide();
  //     Swal.fire(
  //       'Failure!',
  //       'Network Issue!',
  //       'error'
  //     )
  //});
  //}

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    debugger
    this.openModal(template);
    if (model !== undefined) {
      console.log(model);
      this.itemVm = model;
      this.itemVm.transactionDate = this._uow.defaultService.CutTimeZone(this.itemVm.transactionDate);
      this.itemVm.requiredDate = this._uow.defaultService.CutTimeZone(this.itemVm.requiredDate);
    } else { this.itemVm = undefined; }
  }

  // extrnal components
  onItemSubmitted(e) {
    document.location.reload();
    console.log(e);
    if (e === true) {
      this.itemVm = new SavePurchaseMasterRequest();
      this.getList();
    }
  }

  openDeleteModel(template: TemplateRef<any>, model?) {
    this.openModal(template);
    if (model !== undefined) {
      this.itemVm = model;
      this.deleteId = model.uniqueId;
    }
  }

  conformDelete() {
    this.spinner.show();
    this._uow.gPurchaseService.DeletePurchaseRequisiteAsync(this.deleteId).subscribe((res: any) => {
      this.getList();
      this.modalRef.hide();
      this.spinner.hide();
    }, (err) => {
      // this._jq.showSpinner();
      this.spinner.hide();
    });
  }

}
